// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"987dca80","795":"2dca7fe6"}[chunkId] + ".chunk.js";
};